import i18n from "PFCore/i18n";

const SECTION_TITLES_BY_KEY: Record<string, () => string> = {
  credentials: () => i18n.t("profiles:edit.emailAndPassword"),
  notifications: () => i18n.t("profiles:edit.notificationsTitle"),
  language_settings: () => i18n.t("profiles:edit.languageSettings"),
  terms_and_conditions: () => i18n.t("profiles:edit.termsAndConditions"),
  privacy_policy: () => i18n.t("profiles:edit.privacyPolicy"),
  delete_user: () => i18n.t("profiles:edit.deleteAccount"),
  details: () => i18n.t("profiles:edit.basicInfoAndExpertise"),
  availability: () => i18n.t("profiles:edit.availability"),
  positions: () => i18n.t("profiles:edit.positions"),
  contact_information: () => i18n.t("profiles:edit.contactInformation"),
  admin_credentials: () => i18n.t("profiles:edit.emailAndPermissionGroup"),
  calendars: () => i18n.t("profiles:edit.calendars")
};

export const getProfileSectionText = (section: string): string => SECTION_TITLES_BY_KEY[section]?.() ?? "";
